// extracted by mini-css-extract-plugin
export default {"styled_table":"Leader-Board_styled_table__M7RfT","table_holder":"Leader-Board_table_holder__s5jgz"};